import {
  DEFAULT_PAGE_WIDTH,
  Divider,
  Text,
  FlatListSearchable,
} from "@towersystems/roam-common-native";
import { StockOrder } from "@towersystems/roam-common/lib/generated-types";
import { Spacings, View } from "react-native-ui-lib";
import { ListItemTypes } from "../../../../utilities/list/constants";
import { SaleResourceListItemSkeleton } from "../../../sales/components/SaleResourceListItemSkeleton";
import React from "react";
import { ListWrapper } from "../../../../utilities/list/types";
import { StockOrderResourceListItem } from "./components";
import { useTranslation } from "../../../../utilities/i18n";

interface StockOrderResourceListProps {
  loading?: boolean;
  limit?: number;
  items: StockOrder[];
  onEndReached?: () => void;
}

export const StockOrderResourceList = ({
  items,
  limit = 20,
  loading,
  onEndReached,
}: StockOrderResourceListProps) => {
  const { t } = useTranslation("stockorder");

  const renderItem = React.useCallback(
    ({ item, index }: { item: ListWrapper<StockOrder>; index: any }) => {
      if (item.type === ListItemTypes.placeholder) {
        return <SaleResourceListItemSkeleton key={index} />;
      } else {
        return <StockOrderResourceListItem item={item.item} />;
      }
    },
    []
  );

  return (
    <FlatListSearchable
      placeholder={`${t("common:search")}...`}
      style={{
        marginBottom: Spacings.s5,
      }}
      contentContainerStyle={{
        maxWidth: DEFAULT_PAGE_WIDTH,
        width: "100%",
        alignSelf: "center",
        paddingHorizontal: Spacings.s5,
        paddingTop: Spacings.s5,
      }}
      searchBarContainerStyle={{ marginBottom: Spacings.s4 }}
      ItemSeparatorComponent={Divider}
      renderItem={renderItem}
      refreshing={loading}
      data={[
        ...items.map((item) => ({
          type: ListItemTypes.item,
          item,
        })),
        ...(loading
          ? Array(limit).fill({ type: ListItemTypes.placeholder })
          : []),
      ]}
      scrollEnabled={true}
      nestedScrollEnabled
      renderSearchBarHeader={() => <View />}
      ListEmptyComponent={<Text>No items to show</Text>}
      onEndReachedThreshold={0.3}
      onEndReached={() => {
        items.length >= 1 && onEndReached && onEndReached();
      }}
    ></FlatListSearchable>
  );
};
